import React, { useEffect, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, FormControl,
	FormLabel, FormGroup
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer, PdfSiglePage, PdfAllPages } from 'components';
import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';
import {
	SetFormState, GetAlgorithmsDates, RunOvershootingByCoordinates
} from '../../actions/AlgorithmsActions';
// import pdfTest from '../../../../components/PdfViewer/test.pdf';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const CoverageHoles = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	return (
		<div className={classes.fields}>
			{/* New row */}
			<Grid container spacing={4}>
				<Grid item md={12} xs={12}>
					{/* <PdfSiglePage pdf={pdfTest} /> */}
					{/* <PdfAllPages pdf={pdfTest}/> */}
					<h2>Under construction</h2>
				</Grid>
			</Grid>
			{/* New row */}
			<Grid container spacing={4}>
				<Grid item md={6} xs={6}>

				</Grid>
			</Grid>
		</div>
	);
};

export default CoverageHoles;
